class AreabrisbaneController {
    constructor (uiService) {

        uiService.showCarusel();
    }
}

AreabrisbaneController.$inject = ['uiService'];


export {AreabrisbaneController};



/** WEBPACK FOOTER **
 ** ./src/app/components/areabrisbane/areabrisbane.controller.js
 **/